import React from 'react';
import styled from 'styled-components';
import Window from '../Window';

const ImagePreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f8f9fa;
`;

const ImageContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: white;
  border-radius: 8px;
  margin: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const PhotoPlaceholder = styled.div`
  width: 300px;
  height: 400px;
  background: ${props => props.gradient || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 48px;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${props => props.overlay || 'linear-gradient(45deg, rgba(255, 255, 255, 0.1) 25%, transparent 25%)'};
    background-size: 20px 20px;
    background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
  }
`;

const ImageInfo = styled.div`
  text-align: center;
  margin-top: 16px;
`;

const ImageTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #333;
`;

const ImageDetails = styled.p`
  margin: 0;
  font-size: 12px;
  color: #666;
`;

const ImagePreviewApp = ({ variant = 'left', ...windowProps }) => {
  // Different photo variants for left and right windows
  const photoVariants = {
    left: {
      gradient: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
      overlay: 'linear-gradient(45deg, rgba(255, 255, 255, 0.05) 25%, transparent 25%)',
      emoji: '👩‍💼'
    },
    right: {
      gradient: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
      overlay: 'linear-gradient(45deg, rgba(255, 255, 255, 0.08) 25%, transparent 25%)',
      emoji: '😊'
    }
  };

  const variantData = photoVariants[variant] || photoVariants.left;

  return (
    <Window {...windowProps} size={{ width: 400, height: 500 }}>
      <ImagePreviewContainer>
        <ImageContainer>
          <div>
            <PhotoPlaceholder 
              gradient={variantData.gradient}
              overlay={variantData.overlay}
            >
              {variantData.emoji}
            </PhotoPlaceholder>
            <ImageInfo>
              <ImageTitle>IMGlol41.heic</ImageTitle>
              <ImageDetails>Professional headshot • 2.3 MB</ImageDetails>
            </ImageInfo>
          </div>
        </ImageContainer>
      </ImagePreviewContainer>
    </Window>
  );
};

export default ImagePreviewApp;
